import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Dialog from 'components/ContextDialog';
import { getLiteral } from 'utils/getLiteral';
import Slider from 'material-ui/Slider';
import AvatarEditor from 'react-avatar-editor';
import Literal from 'components/Literal'; // FIXME Please use getLiteral here
import { CancelIcon } from 'components/icons';
import './CropImageDialog.scss';
import { ButtonDefault, ButtonPrimary } from 'components/buttons';

class CropImageDialog extends PureComponent {
    state = { scale: 1.2 };

    _renderTitleDialog = () => {
        return (
            <div className="cropImageDialogHeader">
                {getLiteral('title_edit_photo')}
                <CancelIcon onClick={() => this.props.onClose()} />
            </div>
        );
    };

    onAccept = () => {
        const { onAccept } = this.props;

        if (this.cropper) {
            const canvas = this.cropper.getImage();
            onAccept(canvas.toDataURL());
        }
    };

    renderFooter = () => {
        const { onClose } = this.props;
        return (
            <div className="footer-dialog">
                <ButtonDefault onClick={onClose}>
                    <Literal literal="action_cancel" />
                </ButtonDefault>
                <ButtonPrimary onClick={this.onAccept}>
                    <Literal literal="action_accept" />
                </ButtonPrimary>
            </div>
        );
    };

    handleScale = (event, value) => {
        this.setState({ scale: value });
    };

    setCropperRef = (cropper) => (this.cropper = cropper);

    renderCropper = () => {
        const { image, cropperSize, rounded = true } = this.props;

        const scale = this.state.scale;
        return (
            <div>
                <div className="contentDialog">
                    <AvatarEditor
                        image={image}
                        width={cropperSize}
                        height={cropperSize}
                        border={0}
                        color={[255, 255, 255, 1]} // RGBA
                        scale={scale}
                        rotate={0}
                        borderRadius={rounded ? cropperSize / 2 : 0}
                        ref={this.setCropperRef}
                        style={{ cursor: 'move' }}
                    />
                </div>

                <Slider min={0.7} max={2.2} defaultValue={scale} onChange={this.handleScale} />
            </div>
        );
    };

    render() {
        const { show, onClose } = this.props;
        let renderFooter = this.renderFooter();
        let renderCropper = this.renderCropper();
        return (
            <Dialog
                title={this._renderTitleDialog()}
                open={show}
                onRequestClose={onClose}
                className="cropImageDialog dialogBlockOutsideClick"
                titleClassName="header-dialog"
                bodyClassName="body-dialog"
                contentStyle={{ maxWidth: 400 }}
                autoScrollBodyContent={true}
            >
                {renderCropper}
                {renderFooter}
            </Dialog>
        );
    }
}

CropImageDialog.propTypes = {
    show: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    rounded: PropTypes.bool,
};

export default CropImageDialog;
